import VisuallyHidden from './VisuallyHidden';

export default VisuallyHidden;
